import { render } from "./LeaveBalanceModal.vue?vue&type=template&id=516d2f1f&scoped=true"
import script from "./LeaveBalanceModal.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceModal.vue?vue&type=script&lang=js"

import "./leave-balance-modal.scss?vue&type=style&index=0&id=516d2f1f&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516d2f1f"]])

export default __exports__